import { useId } from 'react'

import type { ComponentProps } from './types'

import * as S from '../styles'

export const Component = ({ name, label, checked, onChange, onBlur, disabled = false, ...rest }: ComponentProps) => {
  const id = useId()

  return (
    <S.CheckboxContainer>
      <S.Checkbox
        checked={checked || false}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        inputProps={{ id }}
        disabled={disabled}
        {...rest}
      />
      {label && <S.Label htmlFor={id}>{label}</S.Label>}
    </S.CheckboxContainer>
  )
}
